// extracted by mini-css-extract-plugin
export default {"sort":"SortOrderFilter_sort__HdQou","reverse":"SortOrderFilter_reverse__yFKcE"};